import { render, staticRenderFns } from "./allFifthForms.vue?vue&type=template&id=3729e69f&scoped=true&"
import script from "./allFifthForms.vue?vue&type=script&lang=js&"
export * from "./allFifthForms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3729e69f",
  null
  
)

export default component.exports